/**
 * @ngdoc directive
 * @name app.endeks.directive:edInputForm
 * @element div
 * @description
 * Yeni değerleme sayfasında + ve - butonları ile number tipinde input elemanı oluşturur.
 * **Note:**
 * @example
 *<example module="endeks.app">
    <file name="index.html">
         <ed-input-form input="vm.odasayisi" minval="1" maxval="30" label="Oda Sayısı"></ed-input-form data>
    </file>
</example>
*/
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('edInputForm', edInputForm);

    function edInputForm() {
        var directive = {
            templateUrl: '/app/valuation/valuation-input.html',
            scope: {
                input: '=',
                defaultval: '=',
                minval: '<',
                maxval: '<',
                iszero: '@',
                placeholder: '@',
                label: '@',
                isfloat: '@',
                isdisabled: '@',
                required: '@',
                incrementRate: '<',
                startValue: '<',
                forcestyle: '@',
                handleOnChange: '&',
                warningText: '=',
                warningTextSecond: '=',
                warningRule: '<',
            },
            restrict: 'EA',
            controller: edInputFormController,
            controllerAs: 'vm',
            bindToController: true,
            link: function(scope, element, attributes,ngModel){
                scope.required = attributes.$attr.required;
                
    
            }
        };
        return directive;

    }

    function edInputFormController() {
        var vm = this;
        vm.decreaseVal = decreaseVal;
        vm.increaseVal = increaseVal;
        vm.checkMinMax = checkDefaultValue;
        
        function checkDefaultValue(val) {
            if(!vm.isfloat && val)
                vm.input = Math.round(val);

            if (vm.defaultval && !val) {
                vm.input = vm.defaultval;
            }
            if (vm.input < vm.minval) {
                vm.input = vm.minval;
                vm.minvalError = true;
            }
            else if (vm.input > vm.maxval) {
                vm.input = vm.maxval;
                vm.maxvalError = true;
            }
            else {
                vm.minvalError = false;
                vm.maxvalError = false;
            }
        }

        function decreaseVal() {
            vm.maxvalError = false;
            if (!vm.input) {
                vm.input = 0;
            }
            if (vm.incrementRate) {
                var decnum = (+vm.incrementRate).countDecimals();
                vm.input = +((+vm.input - +vm.incrementRate).toFixed(decnum));
            }
            else {
                vm.input = +vm.input - 1;
            }

            if (vm.input < vm.minval) {
                vm.input = vm.minval;
                vm.minvalError = true;
                vm.handleChange(vm.input)
                return vm.input;
            }
            else {
                vm.minvalError = false;
                vm.handleChange(vm.input)
                return vm.input;
            }
        }

        function increaseVal() {
            vm.minvalError = false;
            if (!vm.input) {
                vm.input = vm.startValue || 0;
            }
            if (vm.incrementRate) {
                var decnum = (+vm.incrementRate).countDecimals();
                vm.input = +((+vm.input + +vm.incrementRate).toFixed(decnum));
            }
            else {
                vm.input = +vm.input + 1;
            }
            if (vm.input > vm.maxval) {
                vm.input = vm.maxval;
                vm.maxvalError = true;
                vm.handleChange(vm.input)
                return vm.input;
            }
            else {
                vm.maxvalError = false;
                vm.handleChange(vm.input)
                return vm.input;
            }
        }
        vm.handleChange = function() {
            vm.handleOnChange({input:vm.input})
        };

    }
})();